import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { Error } from '@/shared/components/Error/Error';
import { EmptyShowcaseError } from '@/shared/lib/showcaseError';
import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { showcaseRoute } from './routes';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: showcaseRoute,
        meta: {
            plusPaymentPage: 'ShowcaseScreen',
            page: 'showcase',
        },
        component: lazy(() => import('./components/StyledShowcase/StyledShowcase')),
        fallback: RouteSkeleton,
    });

    ctx.addError({
        is: (error) => error instanceof EmptyShowcaseError,
        component: Error,
    });
});

export * from './routes';

export default scenario;
